// import _ from 'lodash';
// import angular from 'angular';

class FolioCollectionController {
  /* @ngInject */
  constructor(
    $rootScope,
    $state,
    $stateParams,
    $filter,
    $timeout,
    $window,
    $document,
    HelperService
  ) {
    const vm = this;

    vm.$onInit = () => {
      $rootScope.pageTitle = vm.folioCollection.title;

      $rootScope.socialImage(
        HelperService.thumbnailSrc(
          vm.folioCollection.thumbnail,
          'h:1500;q:80;f:jpg'
        )
      );

      let folios = vm.folioCollection.fields.folios;

      folios = folios.map(folio => {
        const heroField =
          folio.fields.heroAssets && folio.fields.heroAssets.length
            ? folio.fields.heroAssets
            : folio.fields.assets;
        folio.hero = HelperService.group(heroField)[0];
        return folio;
      });

      vm.folios = folios;

      vm.folioUrl = folio => {
        if (!folio) {
          return ''; // columnify bug?
        }

        return $state.href('index.artist.folioCollection.folio', {
          artistSlug: vm.artist.slug,
          folioSlug: folio.slug,
          i:
            folio.fields.assets.length === 1
              ? folio.fields.assets[0].id
              : undefined,
        });
      };
    };
  }
}

export default FolioCollectionController;
